import { render } from "./admin-partner-list.vue?vue&type=template&id=6139d142&ts=true"
import script from "./admin-partner-list.vue?vue&type=script&lang=ts"
export * from "./admin-partner-list.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__